import { useState } from 'react';

export interface ModalProps {
  isOpen: boolean;
  children?: JSX.Element;
  onClose: () => void;
}

export type SetModalProps = (newState: Partial<ModalProps>) => void;

type StatefulModalProps = Pick<ModalProps, 'isOpen' | 'children'>;

const defaultDrawerProps = {
  isOpen: false,
};

function useModalProps(initialDrawerProps?: Partial<ModalProps>): [ModalProps, SetModalProps] {
  const [state, setState] = useState<StatefulModalProps>({ ...defaultDrawerProps, ...initialDrawerProps });

  const setPartialState = (newState: Partial<StatefulModalProps>): void => {
    setState((prevState: StatefulModalProps) => ({ ...prevState, ...newState }));
  };

  const onClose = (): void => {
    setState((prevState: StatefulModalProps) => ({ ...prevState, isOpen: false }));
  };

  return [{ onClose, ...state }, setPartialState];
}

export default useModalProps;
